import React from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseSelectComponent } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";

export const SampleEssayRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, unitMeasures, modalClose }) => {

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            labTest: isUpdate ? rowInfo?.labTest?.id ?? '' : rowInfo?.id ?? '',
            description: isUpdate ? rowInfo?.description : '',
            quantity: isUpdate ? rowInfo?.quantity : '',
            unitMeasure: isUpdate ? rowInfo?.unitMeasure.id : '',
        },
        validationSchema: Yup.object({
            description: Yup.string().required("Ingrese la descripción de la muestra"),
            quantity: Yup.number().min(1, 'Ingrese un número mayor a 0').required('Ingrese la cantidad'),
            unitMeasure: Yup.string().required("Seleccione una unidad de medida"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Ensayos de Muestras</h4>
            <GradientDecorationLine />
            <Form onSubmit={formikFormData.handleSubmit}>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Cantidad</label>
                    <Input
                        name="quantity"
                        className="form-control text-primary"
                        placeholder="Cantidad"
                        type="number"
                        {...formikFormData.getFieldProps('quantity')}
                        invalid={formikFormData.touched.quantity && !!formikFormData.errors.quantity}
                        onFocus={(e) => e.target.select()}
                    />
                    {formikFormData.touched.quantity && formikFormData.errors.quantity && <FormFeedback>{formikFormData.errors.quantity}</FormFeedback>}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Unidad de Medida</label>
                    <BaseSelectComponent
                        options={unitMeasures.map((um) => ({ value: um.id, label: um.name }))}
                        value={formikFormData.values.unitMeasure}
                        onChange={(value) => formikFormData.setFieldValue("unitMeasure", value)}
                        placeholder="Seleccione Unidad de Medida"
                        error="Seleccione Unidad de Medida"
                        touched={formikFormData.touched.unitMeasure && formikFormData.errors.unitMeasure}
                        status={formikFormData.touched.unitMeasure && formikFormData.errors.unitMeasure ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Descripción</label>
                    <Input
                        name="description"
                        className="form-control text-primary"
                        placeholder="Observaciones"
                        type="textarea"
                        {...formikFormData.getFieldProps('description')}
                        invalid={formikFormData.touched.description && !!formikFormData.errors.description}
                    />
                    {formikFormData.touched.description && formikFormData.errors.description && <FormFeedback>{formikFormData.errors.description}</FormFeedback>}
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => { onClosed() }}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            footer={null}
            children={children_form}
            width={700}
        />
    );
};